import React, { useEffect } from 'react'

import "./datepicker/datepicker.css"

import flatpickr from './datepicker/datepicker'

const DATE_LOCALIZATION = {
  pt: {
    weekdays: {
      shorthand: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      longhand: ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado']
    },
    months: {
      shorthand: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      longhand: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
    },
  },
  en: {
    weekdays: {
      shorthand: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      longhand: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    },
    months: {
      shorthand: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      longhand: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    },
  }
}

function buildLocalizationObj(t, language) {
  return {
    weekdays: {
      longhand: [],
      shorthand: [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')]
    },
    months: {
      shorthand: [],
      longhand: [t('january'), t('february'), t('march'), t('april'), t('may'), t('june'), t('july'), t('august'), t('september'), t('october'), t('november'), t('december')]
    }
  }
}

function SelectDate({ t, handleClose, handleDateClick, language }) {

  useEffect(() => {
    const locMap = buildLocalizationObj(t, language)
    flatpickr('#datepicker', null,
      (date) => {
        handleDateClick(date)
      },
      () => handleClose(),
      locMap || DATE_LOCALIZATION.en
    )
  }, [])

  return (
    <div id="overlay-data" className="text-center overlay">
      <div className="pt-5 container">
        <div className="close" id="close">
          <img src={require(`../../assets/images/ico-close.png`)} alt="X" onClick={handleClose} />
        </div>
        <div>
          <p className="color-white">{t('selectPickupDate')}</p>
          <div className="date-picker open">
            <input type="text" id="datepicker" autoComplete="off" data-dateformat="d F Y" className="w-100" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SelectDate